<template>
  <div class="space-y-1">
    <Input
      :model-value="value as any"
      :hint="error"
      :is-error="!!error"
      :type="type"
      :max-fraction-digits="maxFractionDigits"
      :min="min"
      :max="max"
      :use-grouping="useGrouping"
      v-bind="$attrs"
      @blur="onBlur()"
      @update:model-value="setValue($event as ValueType)"
    />
    <AiValidation :field-name="name" />
  </div>
</template>

<script setup lang="ts" generic="T extends string = 'text', S extends boolean = false">
import { useField } from 'vee-validate';
import { watch } from 'vue';
import Input from './Input.vue';
import AiValidation from './AiValidation.vue';

type ValueType = T extends 'number' ? (S extends false ? number : string) : string;

const props = defineProps<{
  name: string;
  initialValue?: ValueType | null;
  type?: string;
  saveNumberAsString?: S;
  emptyValueTo?: 'null' | 'undefined';
  maxFractionDigits?: number;
  useGrouping?: boolean;
  min?: number;
  max?: number;
  isError?: boolean;
  onBlur?: () => void;
}>();

const {
  errorMessage: error,
  value,
  setValue,
  validate,
} = useField<ValueType | null | undefined>(props.name, undefined, {
  initialValue: props.initialValue,
  validateOnValueUpdate: false,
});

if (props.emptyValueTo) {
  watch(value, (newValue) => {
    const emptyValue = props.emptyValueTo === 'null' ? null : undefined;
    setValue(
      newValue === '' || newValue === undefined || newValue === null ? emptyValue : newValue,
    );
  });
}
if (props.saveNumberAsString) {
  watch(value, (newValue) => {
    setValue(
      props.saveNumberAsString && newValue !== null && newValue !== undefined
        ? (newValue.toString() as ValueType)
        : newValue,
    );
  });
}

const onBlur = () => {
  validate();
  props.onBlur?.();
};

watch(value, () => {
  if (error.value) {
    validate();
  }
});
</script>
